module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "header fixed-top clearfix"
  }, [_c('div', {
    staticClass: "brand"
  }, [_c('a', {
    staticClass: "logo",
    attrs: {
      "href": "dashboard"
    }
  }, [_vm._v("\r\n            CityNeeds\r\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "sidebar-toggle-box hidden-sm hidden-xs",
    staticStyle: {
      "margin-left": "10em"
    }
  }, [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": _vm.toggle_sidebar
    }
  }, [_c('div', {
    staticClass: "fa fa-bars"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "sidebar-toggle-box hidden-lg hidden-md",
    staticStyle: {
      "margin-left": "10em"
    }
  }, [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": _vm.toggle_sidebar_mobile
    }
  }, [_c('div', {
    staticClass: "fa fa-bars"
  })])])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('aside', {
    attrs: {
      "id": "sideToggle"
    }
  }, [_c('div', {
    staticClass: "nav-collapse",
    staticStyle: {
      "margin-top": "0em",
      "overflow": "auto"
    },
    attrs: {
      "id": "sidebar"
    }
  }, [_c('div', {
    staticClass: "leftside-navigation",
    staticStyle: {
      "margin-bottom": "20em"
    }
  }, [_c('ul', {
    staticClass: "sidebar-menu",
    attrs: {
      "id": "nav-accordion"
    }
  }, [_c('li', [_c('a', {
    class: {
      active: _vm.isActive('/dashboard')
    },
    attrs: {
      "href": "dashboard"
    }
  }, [_c('i', {
    staticClass: "fa fa-dashboard"
  }), _vm._v(" "), _c('span', [_vm._v("Dashboard")])])]), _vm._v(" "), _c('li', [_c('a', {
    class: {
      active: _vm.isActive('/users')
    },
    attrs: {
      "href": "users"
    }
  }, [_c('i', {
    staticClass: "fa fa-users"
  }), _vm._v(" "), _c('span', [_vm._v("Users")])])]), _vm._v(" "), _c('li', [_c('a', {
    class: {
      active: _vm.isActive('/cnpros')
    },
    attrs: {
      "href": "cnpros"
    }
  }, [_c('i', {
    staticClass: "fa fa-crosshairs"
  }), _vm._v(" "), _c('span', [_vm._v("CNpros")])])]), _vm._v(" "), _c('li', [_c('a', {
    class: {
      active: _vm.isActive('/businesses')
    },
    attrs: {
      "href": "businesses"
    }
  }, [_c('i', {
    staticClass: "fa fa-briefcase"
  }), _vm._v(" "), _c('span', [_vm._v("Businesses")])])]), _vm._v(" "), _c('li', [_c('a', {
    class: {
      active: _vm.isActive('/contracts')
    },
    attrs: {
      "href": "contracts"
    }
  }, [_c('i', {
    staticClass: "fa fa-tasks"
  }), _vm._v(" "), _c('span', [_vm._v("Contracts")])])]), _vm._v(" "), _c('li', [_c('a', {
    class: {
      active: _vm.isActive('/payments')
    },
    attrs: {
      "href": "payments"
    }
  }, [_c('i', {
    staticClass: "fa fa-money"
  }), _vm._v(" "), _c('span', [_vm._v("Payouts")])])]), _vm._v(" "), _c('li', [_c('a', {
    class: {
      active: _vm.isActive('/cnsurveys')
    },
    attrs: {
      "href": "cnsurveys"
    }
  }, [_c('i', {
    staticClass: "fa fa-crosshairs"
  }), _vm._v(" "), _c('span', [_vm._v("CNsurveys")])])]), _vm._v(" "), _c('li', [_c('a', {
    class: {
      active: _vm.isActive('/forums')
    },
    attrs: {
      "href": "forums"
    }
  }, [_c('i', {
    staticClass: "fa fa-meh-o"
  }), _vm._v(" "), _c('span', [_vm._v("Forums")])])]), _vm._v(" "), _c('li', [_c('a', {
    class: {
      active: _vm.isActive('/referrals')
    },
    attrs: {
      "href": "referrals"
    }
  }, [_c('i', {
    staticClass: "fa fa-users"
  }), _vm._v(" "), _c('span', [_vm._v("Referrals")])])]), _vm._v(" "), _c('li', [_c('a', {
    class: {
      active: _vm.isActive('/cwallets')
    },
    attrs: {
      "href": "cnwallets"
    }
  }, [_c('i', {
    staticClass: "fa fa-money"
  }), _vm._v(" "), _c('span', [_vm._v("CNwallets")])])]), _vm._v(" "), _c('li', [_c('a', {
    class: {
      active: _vm.isActive('/rewards')
    },
    attrs: {
      "href": "rewards"
    }
  }, [_c('i', {
    staticClass: "fa fa-money"
  }), _vm._v(" "), _c('span', [_vm._v("Rewards")])])]), _vm._v(" "), _c('li', [_c('a', {
    class: {
      active: _vm.isActive('/payments')
    },
    attrs: {
      "href": "cnpayments"
    }
  }, [_c('i', {
    staticClass: "fa fa-money"
  }), _vm._v(" "), _c('span', [_vm._v("CNpayments")])])]), _vm._v(" "), _c('li', [_c('a', {
    class: {
      active: _vm.isActive('/cnpaymentsremita')
    },
    attrs: {
      "href": "cnpaymentsremita"
    }
  }, [_c('i', {
    staticClass: "fa fa-glass"
  }), _vm._v(" "), _c('span', [_vm._v(" CNpay (Remita) ")])])]), _vm._v(" "), _c('li', [_c('a', {
    class: {
      active: _vm.isActive('/cnpaymentspaga')
    },
    attrs: {
      "href": "cnpaymentspaga"
    }
  }, [_c('i', {
    staticClass: "fa fa-glass"
  }), _vm._v(" "), _c('span', [_vm._v(" CNpay (PAGA) ")])])]), _vm._v(" "), _c('li', [_c('a', {
    class: {
      active: _vm.isActive('/cndiscounts')
    },
    attrs: {
      "href": "cndiscounts"
    }
  }, [_c('i', {
    staticClass: "fa fa-tasks"
  }), _vm._v(" "), _c('span', [_vm._v(" CNdiscounts ")])])]), _vm._v(" "), _c('li', [_c('a', {
    class: {
      active: _vm.isActive('/cninsurance')
    },
    attrs: {
      "href": "cninsurance"
    }
  }, [_c('i', {
    staticClass: "fa fa-tasks"
  }), _vm._v(" "), _c('span', [_vm._v(" CNinsurance ")])])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('li', [_c('a', {
    class: {
      active: _vm.isActive('/login')
    },
    attrs: {
      "href": "login"
    }
  }, [_c('i', {
    staticClass: "fa fa-power-off"
  }), _vm._v(" "), _c('span', [_vm._v("Logout")])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "top-nav clearfix"
  }, [_c('ul', {
    staticClass: "nav pull-right top-menu"
  }, [_c('li', {
    staticClass: "dropdown"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "data-toggle": "dropdown",
      "href": "#"
    }
  }, [_c('span', {
    staticClass: "username"
  }, [_vm._v("Admin")]), _vm._v(" "), _c('b', {
    staticClass: "caret"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu extended logout"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "settings"
    }
  }, [_c('i', {
    staticClass: "fa fa-cog"
  }), _vm._v(" Settings")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "messages"
    }
  }, [_c('i', {
    staticClass: "fa fa-cog"
  }), _vm._v(" Messages")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "login"
    }
  }, [_c('i', {
    staticClass: "fa fa-key"
  }), _vm._v(" Log Out")])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "settings"
    }
  }, [_c('i', {
    staticClass: "fa fa-gear"
  }), _vm._v(" "), _c('span', [_vm._v("Settings")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6cc5f042"}!./src/components/Main-Header/template.html
// module id = 164
// module chunks = 0